
export default function CategoriesSection() {
  const categories = [
    {
      name: 'Funnel Strategy',
      count: 24,
      icon: 'ri-strategic-line',
      color: 'bg-blue-600',
      description: 'Strategic approaches to funnel planning and execution'
    },
    {
      name: 'Conversion Optimization',
      count: 18,
      icon: 'ri-line-chart-line',
      color: 'bg-green-600',
      description: 'Tips and techniques to improve your conversion rates'
    },
    {
      name: 'Email Marketing',
      count: 15,
      icon: 'ri-mail-line',
      color: 'bg-purple-600',
      description: 'Email sequences and automation strategies'
    },
    {
      name: 'Case Studies',
      count: 12,
      icon: 'ri-file-chart-line',
      color: 'bg-orange-600',
      description: 'Real client success stories and results'
    },
    {
      name: 'Tools & Platforms',
      count: 20,
      icon: 'ri-tools-line',
      color: 'bg-pink-600',
      description: 'Reviews and tutorials for funnel building tools'
    },
    {
      name: 'Industry Trends',
      count: 9,
      icon: 'ri-trending-up-line',
      color: 'bg-indigo-600',
      description: 'Latest trends and future predictions in digital marketing'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Explore by Category
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Find exactly what you're looking for with our organized content categories
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, index) => (
            <div key={index} className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer hover:border-transparent">
              <div className="flex items-center mb-4">
                <div className={`w-12 h-12 ${category.color} rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${category.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                    {category.name}
                  </h3>
                  <span className="text-gray-500 text-sm">{category.count} articles</span>
                </div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {category.description}
              </p>
              <div className="flex items-center text-blue-600 font-medium text-sm group-hover:text-blue-700">
                <span>Browse articles</span>
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Stay Updated</h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
            Subscribe to our newsletter and get the latest funnel insights, case studies, and optimization tips delivered to your inbox weekly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white/20"
            />
            <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}